// Purpose: Generates shared responsive desktop-table and mobile-card collection structure.
export const collectionLayoutStyles = ({ dt }) => `
html[data-ui-brand='bayhive'] .bayhive-responsive-collection {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection > * {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-scroller {
  height: 100%;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-item {
  box-sizing: border-box;
  height: var(--p-bayhive-responsive-collection-item-height, auto);
  padding-block-end: ${dt('bayhive.spacing.sm')};
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-card {
  height: 100%;
  overflow: hidden;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-card > .p-card-body {
  height: 100%;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-card :is(
  .p-card-caption,
  .p-card-title,
  .p-card-subtitle,
  .p-card-content,
  .p-card-footer
) {
  min-width: 0;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-card :is(.p-card-content, .p-card-footer) {
  padding: 0;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-header {
  align-items: center;
  display: flex;
  gap: ${dt('bayhive.spacing.sm')};
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-identity {
  flex: 1 1 auto;
  min-width: 0;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-title,
html[data-ui-brand='bayhive'] .bayhive-responsive-collection-subtitle {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-metadata {
  align-items: center;
  display: grid;
  gap: ${dt('bayhive.spacing.md')};
  grid-template-columns: minmax(0, 1fr) max-content max-content;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-metadata-item {
  display: grid;
  gap: ${dt('bayhive.spacing.xs')};
  min-width: 0;
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-metadata-item > small {
  color: ${dt('text.muted.color')};
}

html[data-ui-brand='bayhive'] .bayhive-responsive-collection-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: ${dt('bayhive.spacing.xs')};
}
`;

export default collectionLayoutStyles;
